/* global window */
import '../styles/AnnouncementBar.css';
import AppContext from './context/AppContext';
import { bool, func } from 'prop-types';
import React, { useContext, useEffect, useRef } from 'react';
import useIsRendered from '../hooks/useIsRendered';


export default function AnnouncementBar({ setAnnouncementBarHeight, showStickyHeader }) {
    const { appContext } = useContext(AppContext);
    const announcementBarRef = useRef();
    const { isRendered } = useIsRendered();

    useEffect(() => {
        if (!isRendered) {
            return;
        }
        const handleResize = () => {
            if (announcementBarRef.current) {
                setAnnouncementBarHeight(announcementBarRef.current.offsetHeight);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isRendered, setAnnouncementBarHeight]);

    return (<div
        ref={announcementBarRef}
        style={{
            ...showStickyHeader && ({
                position: 'fixed',
                top: 0,
                zIndex: 1000,
                width: '100%',
            }),
        }}
        className={'announcement-bar'}>
        {appContext.config.storefrontAnnouncement}
    </div>);
}

AnnouncementBar.propTypes = {
    setAnnouncementBarHeight: func,
    showStickyHeader: bool,
};